<template>
	<div class="container">
		<el-container>
			<el-header class="header">
				<headers /></el-header>
			<el-container>
				<slider />
				<el-main>
					<div class="main_box">
						<div class="main_main">
				
							<!-- Page Header -->
							<div class="page_header">
								Define General Training Items
							</div>
							<div v-if="recordId" style="padding-left: 24px">
								<h2 class="page-title">
									Training Overview
								</h2>
				
								<el-link type="primary" :underline="false" class="back-link">
									{{ recordName }}
								</el-link>
							</div>
							<div class="page_main">
								<div class="training-page">
									<!-- Query Area -->
									<el-form ref="query" :model="query"
										label-position="top"
										class="search-form">
										<div class="form-grid">
											<!-- Left -->
											<div class="form-col">
				
												<el-form-item label="Name">
													<el-input v-model="query.title"
														placeholder="Please enter"
														clearable />
												</el-form-item>
				
											</div>
											<!-- Right -->
											<div class="form-col">
				
												<el-form-item label="Description">
													<el-input v-model="query.description"
														placeholder="Please enter"
														clearable />
												</el-form-item>
											</div>
										</div>
										<div class="form-btns">
				
											<el-button type="primary" @click="handleSearch">
												Search
											</el-button>
				
											<el-button type="primary" @click="handleAdd">
												Add
											</el-button>
										</div>
									</el-form>
									<div class="content-card">
										<div class="content-header">
				
											<div class="title">
												General Training Items
											</div>
				
										</div>
										<el-table v-loading="tableLoading"
											:data="tableData"
											border stripe
											header-cell-class-name="table-header-cell"
											class="training-table"
											@selection-change="handleSelectionChange">
				
				
											<el-table-column v-if="recordId"
												type="selection"
												width="50"
												align="center" />
				
				
											<el-table-column label="Actions"
												width="80"
												align="center">
				
												<template slot-scope="scope">
				
													<el-button size="mini"
														type="primary"
														@click="handleEdit(scope.row)">
														Edit
													</el-button>
				
												</template>
				
											</el-table-column>
											<el-table-column prop="title"
												label="Title"
												sortable
												show-overflow-tooltip />
											<el-table-column prop="description"
												label="Description"
												sortable
												show-overflow-tooltip />
											<el-table-column label="Actions"
												align="center"
												width="350">
												<template slot-scope="scope">
													<div class="action_btns">
														<el-button size="mini"
															type="primary"
															@click="handleManage(scope.row)">
															Manage Training
														</el-button>
														<el-button v-if="scope.row.status == 1"
															type="warning"
															size="mini"
															@click="handleToggleStatus('Disable', scope.row)">
															Disable
														</el-button>
				
				
														<el-button v-if="scope.row.status == 2"
															type="primary"
															size="mini"
															@click="handleToggleStatus('Enable', scope.row)">
															Enable
														</el-button>
														<el-button size="mini"
															type="danger"
															@click="handleDelete(scope.row)">
															Delete
														</el-button>
													</div>
												</template>
											</el-table-column>
										</el-table>
										<div class="pagination">
											<el-pagination
												@size-change="handleSizeChange"
												@current-change="handlePageChange"
												:current-page="query.page"
												:page-sizes="[5, 10, 20, 50]"
												:page-size="query.page_size"
												layout="total, sizes, prev, pager, next"
												:total="pageTotal">
											</el-pagination>
				
										</div>
										<div v-if="recordId" class="footer-btns">
				
											<el-button type="primary"
												@click="handleAddRecord">
												Add to Training Record
											</el-button>
				
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</el-main>
			</el-container>
		</el-container>
		<!--编辑培训要求-->
		<el-dialog title="编辑培训要求" :visible.sync="recordVisible" width="55%">
			<requirementEdit v-if="recordVisible" :recordId="Number(recordId)" :recordName="recordName"
			:selectedIds="selectedIds" :selectedRows="selectedRows" :type="Number(1)">
			</requirementEdit>
		</el-dialog>
		<!--编辑培训要求-->
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading">
				<van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import {
  trainGerenalList,
  trainGerenalStatus,
  trainGerenalDel,
} from "@/api/trainManage/configTrain/generalTrain/index";
import headers from "@/component/header.vue";
import slider from "@/component/slider.vue";
import requirementEdit from "@/pages/trainManage/configTrain/trainRecord/requirement-edit.vue";
export
default {
	components: {
		headers,
		slider,
		requirementEdit,
	},
	data() {
		return {
			isLoading: true,
			tableLoading: false,
			query: {
				title: "",
				description: "",
				status: "",
				time1: "",
				time2: "",
				page: 1,
				page_size: 10,
			},
			tableData: [],
			pageTotal: 0,
			//总条数
			recordId: null,
			recordName: "",
			selectedIds: [],
			selectedRows: [],
			recordVisible: false,
		};
	},
	created() {
		let that = this;
		if (that.$route.query.recordId) {
			that.recordId = that.$route.query.recordId;
			that.recordName = decodeURIComponent(that.$route.query.recordName);
			that.query.status = 1;
		}
	},
	mounted() {
		let that = this;
		that.isLoading = false;
		that.getTableData();
	},
	methods: {
		//获取表格数据
		getTableData() {
			let that = this;
			that.tableLoading = true;
			trainGerenalList(that.query).then((res) => {
				that.tableLoading = false;
				if (res.code == 200) {
					that.pageTotal = res.data.total;
					that.tableData = res.data.data;
				}
			});
		},
		//搜索
		handleSearch() {
			let that = this;
			that.getTableData();
		},
		//条数选择
		handleSizeChange(value) {
			let that = this;
			that.query.page_size = value;
			that.getTableData();
		},
		//页数跳转
		handlePageChange(value) {
			let that = this;
			that.query.page = value;
			that.getTableData();
		},
		//监控表格多选选中
		handleSelectionChange(selection) {
			this.selectedRows = selection;
			this.selectedIds = selection.map((item) => item.id);
		},
		//添加到培训档案
		handleAddRecord() {
			let that = this;
			if (!that.selectedIds.length) {
				that.$message.warning("Please select a training item first.");
				return;
			}
			that.recordVisible = true;
		},
		handleManage(row) {
			let that = this;
			that.$router.push({
				path: "/TrainControl/manage-train",
				query: {
					type: "overview",
					recordId: row.id,
					recordName: encodeURIComponent(row.title)
				},
			});
		},
		//添加
		handleAdd() {
			let that = this;
			that.goUrl("/TrainControl/general-add-edit");
		},
		//编辑
		handleEdit(row) {
			let that = this;
			that.$router.push({
				path: "/TrainControl/general-add-edit",
				query: {
					oid: row.id
				},
			});
		},
		//切换状态
		handleToggleStatus(type, row) {
			let that = this;
			that.$confirm(
				type == "Disable" ? "Are you sure you want to disable this item?" : "Are you sure you want to enable this item?",
				"Confirmation",
				{
					type: "warning",
				}
			).then(() => {
				that.$toast.loading({
					duration: 0,
					forbidClick: true
				});
				trainGerenalStatus({
					id: row.id,
					status: type == "Disable" ? 2 : 1,
				}).then((res) => {
					if (res.code == 200) {
						that.$toast.clear();
						that.$message.success("Operation successful");
						row.status = type == "Disable" ? 2 : 1;
					}
				});
			}).catch(() => {});
		},
		//删除
		handleDelete(row) {
			let that = this;
			that.$confirm("Are you sure you want to delete this training file?", "Confirmation", {
				type: "warning",
			}).then(() => {
				that.$toast.loading({
					duration: 0,
					forbidClick: true
				});
				trainGerenalDel({
					id: row.id
				}).then((res) => {
					if (res.code == 200) {
						that.$toast.clear();
						that.$message.success("Operation successful");
						setTimeout(() => {
							that.getTableData();
						},
						800);
					}
				});
			}).
			catch(() => {});
		},
		// handleClose() {
		// 	let that = this;
		// 	that.$router.back();
		// },
		//跳转页面
		goUrl(url) {
			let that = this;
			that.$router.push(url);
		},
	},
};
</script>

<style lang="less" scoped>
//主要内容
.main_main {
  .page_main {
    padding: 18px 20px;
    .pagination {
      margin: 10px 0;
      text-align: right;
    }
    .btn_el {
      margin: 10px 0 20px 0;
      .tips {
        padding: 6px 8px;
        background-color: #ffb1001a;
        border-radius: 6px;
        font-size: 16px;
        font-weight: bold;
      }
    }
  }
  //页头
  .page_header {
    padding: 0 20px;
    height: 60px;
    line-height: 60px;
    background-color: #d8e4f0;
    font-size: 24px;
    font-weight: bold;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.075);
  }
}
</style>
<style scoped>
.main_box {
  height: calc(100vh - 60px);
  overflow-y: auto;
}
.main_box .main_main {
  position: relative;
  min-height: calc(100% - 0px);
  max-height: auto;
  background-color: #fafafa;
}
.el-header,
.el-main {
  padding: 0;
}

.training-page {
  min-height: 100%;
  box-sizing: border-box;
}

.tip-box {
  background: #f4efe5;
  border-radius: 4px;
  padding: 14px 18px;
  color: #333;
  font-size: 14px;
  margin-bottom: 14px;
  line-height: 1.8;
}

.tip-box ul {
  margin: 4px 0 0 18px;
  padding: 0;
}

.tab-wrapper {
  margin-bottom: 0;
}

.tab-wrapper ::v-deep.el-tabs__header {
  margin: 0;
}

.tab-wrapper ::v-deep .el-tabs__nav-wrap::after {
  height: 1px;
  background-color: #dcdfe6;
}

.tab-wrapper ::v-deep .el-tabs__item {
  height: 42px;
  line-height: 42px;
  font-size: 15px;
  font-weight: 600;
  color: #333;
}

.tab-wrapper ::v-deep .el-tabs__item.is-active {
  color: #fff;
  background: #0b61a8;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}

.tab-wrapper ::v-deep .el-tabs__active-bar {
  display: none;
}

.content-card {
  background: #fff;
  border: 1px solid #dcdfe6;
  border-top: none;
}

.content-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px;
  border-top: 1px solid #dcdfe6;
  border-bottom: 1px solid #dcdfe6;
}

.title {
  font-size: 22px;
  font-weight: 700;
  color: #222;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 8px;
}

.search-input {
  width: 250px;
}

.collapse-btn {
  padding: 10px 12px;
}

.training-table {
  width: 100%;
}

.training-table ::v-deep .el-table__header-wrapper th {
  background: #fff;
  color: #222;
  font-size: 15px;
  font-weight: 700;
}

.training-table ::v-deep .el-table td,
.training-table ::v-deep .el-table th {
  padding: 10px 0;
}

.training-table ::v-deep.el-button--mini {
  padding: 8px 12px;
  font-size: 14px;
}

.footer-btns {
  display: flex;
  justify-content: center;
  gap: 12px;
  padding: 20px 0 40px 0;
}

.footer-btns .el-button {
  min-width: 80px;
  font-size: 16px;
  padding: 12px 20px;
}

.form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 24px;
  align-items: start;
}
.form-grid .el-form-item {
  margin-bottom: 0;
}

.form-btns {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  margin-top: 20px;
  margin-bottom: 20px;
}

::v-deep .btn span {
  text-decoration: underline;
}
</style>

